
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jeux",
      function () {
        return require("private-next-pages/jeux/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jeux"])
      });
    }
  